'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = require('vue-router');

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _router = require('@/config/interceptors/router');

var _course = require('./course');

var _course2 = _interopRequireDefault(_course);

var _userCenter = require('./user-center');

var _userCenter2 = _interopRequireDefault(_userCenter);

var _play = require('./play');

var _play2 = _interopRequireDefault(_play);

var _qusetionnaire = require('./qusetionnaire');

var _qusetionnaire2 = _interopRequireDefault(_qusetionnaire);

var _exam = require('./exam');

var _exam2 = _interopRequireDefault(_exam);

var _dxExam = require('./dx-exam');

var _dxExam2 = _interopRequireDefault(_dxExam);

var _teacher = require('./teacher');

var _teacher2 = _interopRequireDefault(_teacher);

var _class = require('./class');

var _class2 = _interopRequireDefault(_class);

var _dxClass = require('./dx-class');

var _dxClass2 = _interopRequireDefault(_dxClass);

var _onLine = require('./on-line');

var _onLine2 = _interopRequireDefault(_onLine);

var _resources = require('./resources');

var _resources2 = _interopRequireDefault(_resources);

var _notice = require('./notice');

var _notice2 = _interopRequireDefault(_notice);

var _myOrder = require('./myOrder');

var _myOrder2 = _interopRequireDefault(_myOrder);

var _noticeAnnouncement = require('./notice-announcement');

var _noticeAnnouncement2 = _interopRequireDefault(_noticeAnnouncement);

var _learnMap = require('./learnMap');

var _learnMap2 = _interopRequireDefault(_learnMap);

var _specialPage = require('./specialPage');

var _specialPage2 = _interopRequireDefault(_specialPage);

var _activityCenter = require('./activityCenter');

var _activityCenter2 = _interopRequireDefault(_activityCenter);

var _experienceBase = require('./experienceBase');

var _experienceBase2 = _interopRequireDefault(_experienceBase);

var _project = require('./project');

var _project2 = _interopRequireDefault(_project);

var _dynamic = require('./dynamic');

var _dynamic2 = _interopRequireDefault(_dynamic);

var _studyStar = require('./studyStar');

var _studyStar2 = _interopRequireDefault(_studyStar);

var _channel = require('./channel');

var _channel2 = _interopRequireDefault(_channel);

var _certificateQuery = require('./certificate-query');

var _certificateQuery2 = _interopRequireDefault(_certificateQuery);

var _toonAuth = require('./toon-auth');

var _toonAuth2 = _interopRequireDefault(_toonAuth);

var _applicationRecommend = require('./applicationRecommend');

var _applicationRecommend2 = _interopRequireDefault(_applicationRecommend);

var _microLesson = require('./microLesson');

var _microLesson2 = _interopRequireDefault(_microLesson);

var _workVideo = require('./workVideo');

var _workVideo2 = _interopRequireDefault(_workVideo);

var _mystudy = require('./mystudy');

var _mystudy2 = _interopRequireDefault(_mystudy);

var _jingcaizhibo = require('./jingcaizhibo');

var _jingcaizhibo2 = _interopRequireDefault(_jingcaizhibo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var retrieve = function retrieve() {
  return import('@/page/retrieve/retrieve');
};
// 新加

var resetPasswords = function resetPasswords() {
  return import('@/page/resetPasswords/resetPasswords');
}; // 修改密码路由
var resetPhone = function resetPhone() {
  return import('@/page/resetPhone/resetPhone');
}; // 修改手机号路由
var bindPhone = function bindPhone() {
  return import('@/page/bindPhone/bindPhone');
}; // 绑定手机号路由
var validPhone = function validPhone() {
  return import('@/page/validPhone/validPhone');
}; // 互联网端二次登录路由
// const registerPhone = () => import('@/page/registerPhone/registerPhone') //手机号注册
var resetPasswordPhone = function resetPasswordPhone() {
  return import('@/page/resetPasswordPhone/resetPasswordPhone');
};
var bandingPhone = function bandingPhone() {
  return import('@/page/bandingPhone/bandingPhone');
};
var bandingOk = function bandingOk() {
  return import('@/page/bandingOk/bandingOk');
};
var agreement = function agreement() {
  return import('@/page/agreement/agreement');
};
var login = function login() {
  return import('@/page/login/login');
};
var logintest = function logintest() {
  return import('@/page/login/login-test');
};
var oauthLogin = function oauthLogin() {
  return import('@/page/login/oauth-login');
};
var toonLogin = function toonLogin() {
  return import('@/page/login/toon-login');
}; // 北京市统一身份认证
var index = function index() {
  return import('@/page/index');
};
var nopermission = function nopermission() {
  return import('@/page/nopermission');
};
var pdfpreview = function pdfpreview() {
  return import('@/page/pdfpreview');
};
var loading = function loading() {
  return import('@/page/login/loading');
};
_vue2.default.use(_vueRouter2.default);
var routes = exports.routes = [{
  path: '/',
  name: 'index',
  component: index
}, {
  path: '/pdfpreview',
  name: 'pdfpreview',
  component: pdfpreview
}, {
  path: '/nopermission',
  name: 'nopermission',
  component: nopermission
},
// {
//   path: '/index',
//   name: 'index',
//   component: index
// },
{
  path: '/login',
  name: 'login',
  component: login
}, {
  path: '/logintest',
  name: 'logintest',
  component: logintest
}, {
  path: '/oauthLogin',
  name: 'oauthLogin',
  component: oauthLogin
}, {
  path: '/toonLogin',
  name: 'toonLogin',
  component: toonLogin
}, {
  path: '/retrieve',
  name: 'retrieve',
  component: retrieve
}, {
  path: '/validPhone',
  name: 'validPhone',
  component: validPhone
}, {
  path: '/resetPasswords',
  name: 'resetPasswords',
  component: resetPasswords
}, {
  path: '/resetPhone',
  name: 'resetPhone',
  component: resetPhone
}, {
  path: '/bindPhone',
  name: 'bindPhone',
  component: bindPhone
},
// {
//   path: '/registerPhone',
//   name: 'registerPhone',
//   component: registerPhone
// },
{
  path: '/resetPasswordPhone',
  name: 'resetPasswordPhone',
  component: resetPasswordPhone
}, {
  path: '/bandingPhone',
  name: 'bandingPhone',
  component: bandingPhone
}, {
  path: '/bandingOk',
  name: 'bandingOk',
  component: bandingOk
}, {
  path: '/agreement',
  name: 'agreement',
  component: agreement
}, {
  path: '/loading',
  name: 'loading',
  component: loading
}].concat((0, _toConsumableArray3.default)(_course2.default), (0, _toConsumableArray3.default)(_userCenter2.default), (0, _toConsumableArray3.default)(_play2.default), (0, _toConsumableArray3.default)(_qusetionnaire2.default), (0, _toConsumableArray3.default)(_teacher2.default), (0, _toConsumableArray3.default)(_exam2.default), (0, _toConsumableArray3.default)(_dxExam2.default), (0, _toConsumableArray3.default)(_resources2.default), (0, _toConsumableArray3.default)(_class2.default), (0, _toConsumableArray3.default)(_dxClass2.default), (0, _toConsumableArray3.default)(_onLine2.default), (0, _toConsumableArray3.default)(_notice2.default), (0, _toConsumableArray3.default)(_myOrder2.default), (0, _toConsumableArray3.default)(_noticeAnnouncement2.default), (0, _toConsumableArray3.default)(_learnMap2.default), (0, _toConsumableArray3.default)(_specialPage2.default), (0, _toConsumableArray3.default)(_activityCenter2.default), (0, _toConsumableArray3.default)(_experienceBase2.default), (0, _toConsumableArray3.default)(_project2.default), (0, _toConsumableArray3.default)(_dynamic2.default), (0, _toConsumableArray3.default)(_studyStar2.default), (0, _toConsumableArray3.default)(_channel2.default), (0, _toConsumableArray3.default)(_certificateQuery2.default), (0, _toConsumableArray3.default)(_toonAuth2.default), (0, _toConsumableArray3.default)(_applicationRecommend2.default), (0, _toConsumableArray3.default)(_microLesson2.default), (0, _toConsumableArray3.default)(_workVideo2.default), (0, _toConsumableArray3.default)(_mystudy2.default), (0, _toConsumableArray3.default)(_jingcaizhibo2.default));
var routerInstance = new _vueRouter2.default({
  routes: routes,
  scrollBehavior: function scrollBehavior(to, from, savePosition) {
    return {
      x: 0,
      y: 0
    };
  }
});
routerInstance.beforeEach(_router.routerBeforeEach);
routerInstance.afterEach(_router.routerAfterEach);
exports.default = routerInstance;